import { initializeApp } from 'firebase/app';
import { getAuth, applyActionCode, checkActionCode } from 'firebase/auth';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';

// Environment config from env files
const APP_ENV = process.env.REACT_APP_ENV || 'development';
const USE_EMULATORS = process.env.REACT_APP_USE_EMULATORS === 'true';
const EMULATOR_HOST = process.env.REACT_APP_EMULATOR_HOST || 'localhost';
const FUNCTIONS_PORT = 5001;

// Firebase config from environment
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_SENDER_ID,
  appId: process.env.REACT_APP_FB_APP_ID,
  measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID,
};

// Production: no config logging

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const functions = getFunctions(app);

// Connect to emulators if enabled
if (USE_EMULATORS) {
  try {
    connectFunctionsEmulator(functions, EMULATOR_HOST, FUNCTIONS_PORT);
  } catch (error) {
    // Silently ignore emulator connection errors
  }
}

export { app, auth, functions, httpsCallable, applyActionCode, checkActionCode };

